import { FC, useEffect } from "react";
import { Loader } from "@/components";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useChallengeSlugForRedirect } from "@/features/challenge/hooks/useChallengeSlugForRedirect";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";

const F1Challenge: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { data: slug, loading, error } = useChallengeSlugForRedirect("f12024");

  useEffect(() => {
    if (!loading && slug) {
      navigate(`${siteRoutes["challengesAndSlug"]}${slug}`);
    }
  }, [slug]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <FormErrorMessage isVisible text={error.message} />;
  }

  return null;
};

export default F1Challenge;
